import { BASEURL, Request, TRequestMethod } from "./request.ts";
import { Schema } from "./validation.ts";

/*
Der Webservice fdw_Statistics gibt eine für diese Anfrage eindeutige ID zurück, 
welche für die weiteren Webservices zu der jeweiligen Anfrage mitgegeben werden muss.
*/

export type FDWStatItemResponse = string;

export class FDWStatItem extends Request<FDWStatItemResponse>{
    method : TRequestMethod = "POST";
    responseSchema : Schema = 'string';

    constructor (
        public session_id: string,
        public item: Array<string>){
        super();
    }

    route() : string{
        return `${BASEURL}/fdw_stat_item/`;
    }
}